import PrivateLayout from 'layout/PrivateLayout';
import { flatMap } from 'lodash';
// import Home from 'pages/Home';
import React from 'react';
import { RouteObject } from 'react-router-dom';
import Users from 'pages/Users';
import OrderManagement from 'pages/OrderManagement';
import Settings from 'pages/Settings';
import TransferOrder from 'pages/TransferOrder';
import OrdersReturn from 'pages/OrdersReturn';
import Customers from 'pages/Customers';
import ChainStores from 'pages/ChainStores';
import Inventory from 'pages/Inventory';
import InProcessOrders from 'pages/InProcessOrders';
import BatchManagement from 'pages/BatchManagement';
import OrdersExchange from 'pages/OrdersExchange';
import OrdersTabTryBuy from 'pages/OrdersTabTryBuy';
import RolePermissions from 'pages/RolePermissions';

type CheckRoles = {
  endpoint: string | string[];
  method: string;
  bypass?: boolean;
};

type PrivateRouteType = {
  path: string;
  element?: React.ReactNode;
  customCreateBtn?: React.ReactNode;
  isCreateModal?: boolean;
  children?: (RouteObject & {
    hiddenCreateButton?: boolean;
    title?: string;
    isFull?: boolean;
    customRootPath?: string;
    checkRoles?: CheckRoles;
  })[];
  title?: string;
  hiddenCreateButton?: boolean;
  checkRoles?: CheckRoles;
};

export const RAW_PRIVATE_ROUTES: PrivateRouteType[] = [
  {
    path: '/',
    element: <OrderManagement.List />,
    hiddenCreateButton: true,
    checkRoles: {
      endpoint: '/orders',
      method: 'GET',
    },
  },
  //TODO: DON'T REMOVE ==> register router{

  {
    path: '/users',
    element: <></>,
    children: [
      {
        path: '',
        element: <Users.List />,
        title: 'Users',
        checkRoles: {
          endpoint: '/users',
          method: 'GET',
        },
      },
      {
        path: 'create',
        element: <Users.Create />,
        title: 'Users Create',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/users',
          method: 'POST',
        },
      },
      {
        path: ':id/edit',
        element: <Users.Edit />,
        title: 'Users Edit',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/users/:id',
          method: 'GET',
        },
      },
    ],
  },
  {
    path: '/order-management',
    element: <></>,
    children: [
      {
        path: '',
        element: <OrderManagement.List />,
        title: 'Order Management',
        hiddenCreateButton: true,
      },
      {
        path: ':id/show',
        element: <OrderManagement.Show />,
        title: 'Show Orders',
        hiddenCreateButton: true,
      },
      {
        path: ':id/detail',
        element: <OrderManagement.OrdersPickingDetail />,
        title: 'Batch Detail',
        hiddenCreateButton: true,
      },
    ],
  },
  {
    path: '/orders-exchange',
    element: <></>,
    children: [
      {
        path: '',
        element: <OrdersExchange.List />,
        title: 'Orders Exchange Management',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/orders-exchange',
          method: 'GET',
        },
      },
      {
        path: ':id/show',
        element: <OrdersExchange.Show />,
        title: 'Show Orders Exchange',
        checkRoles: {
          endpoint: '/orders-exchange/:id',
          method: 'GET',
        },
      },
      // {
      //   path: ':id/detail',
      //   element: <OrderManagement.OrdersPickingDetail />,
      //   title: 'Batch Detail',
      //   hiddenCreateButton: true,
      // },
    ],
  },
  {
    path: '/orders-keep-and-try',
    element: <></>,
    children: [
      {
        path: '',
        element: <OrdersTabTryBuy.List />,
        title: 'Keep & Try Management',
        hiddenCreateButton: true,
      },
      {
        path: ':id/show',
        element: <OrdersTabTryBuy.Show />,
        title: 'Show Orders Keep & Try',
      },
      // {
      //   path: ':id/detail',
      //   element: <OrderManagement.OrdersPickingDetail />,
      //   title: 'Batch Detail',
      //   hiddenCreateButton: true,
      // },
    ],
  },
  {
    path: '/orders-return',
    element: <></>,
    children: [
      {
        path: '',
        element: <OrdersReturn.List />,
        title: 'Orders Return',
        hiddenCreateButton: window.location.href.includes(
          'ecom-oms.routine.vn',
        ) as boolean,
        checkRoles: {
          endpoint: '/return-orders',
          method: 'GET',
        },
      },
      // {
      //   path: ':id/edit',
      //   element: <Users.Edit />,
      //   title: 'Order Edit',
      //   hiddenCreateButton: true,
      // },
      {
        path: ':id/show',
        element: <OrdersReturn.Show />,
        title: 'Show Order Return',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/return-orders/:id',
          method: 'GET',
        },
      },
      {
        path: 'create',
        element: <OrdersReturn.Create />,
        title: 'Create Order Return',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/return-orders',
          method: 'POST',
        },
      },
    ],
  },
  {
    path: '/transfer-orders',
    element: <></>,
    children: [
      {
        path: '',
        element: <TransferOrder.List />,
        title: 'Transfer Order',
        // hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/transfer-orders',
          method: 'GET',
        },
      },
      {
        path: 'create',
        element: <TransferOrder.Create />,
        hiddenCreateButton: true,
        title: 'Create Transfer Order',
        checkRoles: {
          endpoint: '/transfer-orders',
          method: 'POST',
        },
      },
      {
        path: ':id/edit',
        element: <TransferOrder.Edit />,
        title: 'Transfer Order Edit',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/transfer-orders/:id',
          method: 'GET',
        },
      },
      {
        path: ':id/show',
        element: <TransferOrder.Show />,
        title: 'Show Transfer Order',
        checkRoles: {
          endpoint: '/transfer-orders/:id',
          method: 'GET',
        },
      },
      {
        path: ':id/detail',
        element: <TransferOrder.BathDetail />,
        title: 'Batch Detail',
      },
    ],
  },
  {
    path: '/settings',
    element: <></>,
    children: [
      {
        path: '',
        element: <Settings.CardList />,
        title: 'Settings',
        hiddenCreateButton: true,
      },
      {
        path: 'manage-related-skus',
        element: <Settings.RelatedSKUsList />,
        title: 'Manage related SKUs',
        customRootPath: 'settings/manage-related-skus',
      },
      {
        path: 'manage-related-skus/create',
        element: <Settings.RelatedSKUsCreate />,
        title: 'New SKU',
        hiddenCreateButton: true,
      },
      {
        path: 'manage-related-skus/:id/edit',
        element: <Settings.RelatedSKUsEdit />,
        title: 'Detail SKU',
        hiddenCreateButton: true,
      },

      {
        path: 'warehouse-locations',
        element: <Settings.LocationsList />,
        title: 'Warehouse Locations',
        customRootPath: 'settings/warehouse-locations',
        checkRoles: {
          endpoint: '/locations',
          method: 'GET',
        },
      },
      {
        path: 'warehouse-locations/create',
        element: <Settings.LocationCreate />,
        title: 'New Warehouse Location',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/locations',
          method: 'POST',
        },
      },
      {
        path: 'warehouse-locations/:id/edit',
        element: <Settings.LocationEdit />,
        title: 'Detail Warehouse Location',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/locations/:id',
          method: 'GET',
        },
      },
      {
        path: 'bannedCustomers',
        element: <Customers.BannedCustomers />,
        title: 'Customer Blacklist',
        customRootPath: 'settings/bannedCustomers',
        checkRoles: {
          endpoint: ['/customers', '/customers/bans/:id'],
          method: 'GET',
        },
      },
      {
        path: 'bannedCustomers/create',
        element: <Customers.Create />,
        title: 'Customer Blacklist',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/customers/bans/:id',
          method: 'POST',
        },
      },
      {
        path: 'bannedCustomers/:id/edit',
        element: <Customers.Edit />,
        title: 'Detail Customer Blacklist',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/customers/:id',
          method: 'GET',
        },
      },
      {
        path: 'bannedCustomers/:id/show',
        element: <Customers.Show />,
        title: 'Show Customer Blacklist',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/customers/:id',
          method: 'GET',
        },
      },
      {
        path: 'chainStores',
        element: <ChainStores.List />,
        title: 'Brands',
        customRootPath: 'settings/chainStores',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/chain-stores',
          method: 'GET',
        },
      },
      {
        path: 'chainStores/:id/edit',
        element: <ChainStores.Edit />,
        title: 'Detail Brand',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/chain-stores/:id',
          method: 'GET',
        },
      },
      {
        path: 'locationStockChanges',
        element: <Settings.LocationStockChangesList />,
        title: 'Location Stock Changes',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/location-stock-changes',
          method: 'GET',
        },
      },
    ],
  },
  {
    path: '/inventory',
    element: <></>,
    children: [
      {
        path: '',
        element: <Inventory.List />,
        title: 'Inventory',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/inventories',
          method: 'GET',
        },
      },
      {
        path: 'inProcessOrders',
        element: <InProcessOrders.List />,
        title: 'In Process Orders',
        hiddenCreateButton: true,
        customRootPath: 'inventory/inProcessOrders',
        checkRoles: {
          endpoint: '/order-item-stocks',
          method: 'GET',
        },
      },
    ],
  },
  {
    path: '/batch-management',
    element: <></>,
    children: [
      {
        path: '',
        element: <BatchManagement.List />,
        title: 'Batch Management',
        hiddenCreateButton: true,
        checkRoles: {
          endpoint: '/order-batches',
          method: 'GET',
        },
      },
    ],
  },
  {
    path: '/rolePermissions',
    element: <></>,
    children: [
      {
        path: '',
        element: <RolePermissions.List />,
        title: 'Role Permissions',
        // roles: ['admin'],
        checkRoles: {
          endpoint: '/roles',
          method: 'GET',
        },
      },
      {
        path: 'create',
        element: <RolePermissions.Create />,
        title: 'Role',
        hiddenCreateButton: true,
        // roles: ['admin'],
        checkRoles: {
          endpoint: '/roles',
          method: 'POST',
        },
      },
      {
        path: ':id/edit',
        element: <RolePermissions.Edit />,
        title: 'Detail Role',
        hiddenCreateButton: true,
        // roles: ['admin'],
        checkRoles: {
          endpoint: '/roles/:id',
          method: 'GET',
        },
      },
    ],
  },
];

export const PRIVATE_ROUTES = flatMap(
  RAW_PRIVATE_ROUTES.map((e) => ({
    ...e,
    element: (
      <PrivateLayout
        isCreateModal={e.isCreateModal}
        customCreateBtn={e.customCreateBtn}
        hiddenCreateButton={e.hiddenCreateButton}
        title={e.title}
        checkRoles={e.checkRoles}
      >
        {e.element}
      </PrivateLayout>
    ),
    children: e?.children?.map((child) => ({
      ...child,
      path: `${e.path}/${child.path}`,
      element: (
        <PrivateLayout
          hiddenCreateButton={child.hiddenCreateButton || e.hiddenCreateButton}
          isCreateModal={e.isCreateModal}
          customCreateBtn={e.customCreateBtn}
          title={child.title || e.title}
          customRootPath={child?.customRootPath}
          isFull={child.isFull}
          checkRoles={child.checkRoles}
        >
          {child.element}
        </PrivateLayout>
      ),
    })) || [
      {
        ...e,
        hiddenCreateButton: e.hiddenCreateButton,
        element: (
          <PrivateLayout
            isCreateModal={e.isCreateModal}
            customCreateBtn={e.customCreateBtn}
            title={e.title}
            hiddenCreateButton={e.hiddenCreateButton}
            checkRoles={e.checkRoles}
          >
            {e.element}
          </PrivateLayout>
        ),
      },
    ],
  })),
  'children',
);
